import { envVar } from '@env'
import { useAuthState } from '@features/app-hooks'
import { authModule, logout } from '@features/auth/auth-module'
import { Link } from '@features/link'
import { useProcess } from '~/store'
import { cn } from '@util/cn'

export function LoginLogoutLink({ className }: { className?: string }) {
  const { status } = useAuthState()

  if (status == 'loggedIn') {
    return <LogoutLink className={className} />
  }

  return (
    <Link className="active" href={{ name: 'login' }}>
      Log In
    </Link>
  )
}

function LogoutLink({ className }: { className?: string }) {
  const auth = useProcess('auth')

  function onClickLogout() {
    const homepage = envVar('NEXT_PUBLIC_HOMEPAGE_URL')
    auth.send(logout(homepage ? { type: 'url', url: homepage } : { type: 'path', pathname: '/' }))
  }

  return (
    <a
      className={cn('logout-button', className)}
      style={{ cursor: 'pointer' }}
      onClick={onClickLogout}
    >
      Log out
    </a>
  )
}
